var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mr-3",attrs:{"color":"gray","dark":"","medium":""}},[_vm._v(" "+_vm._s(_vm.$t('marketplace.products.addProduct'))+" ")]),_c('v-btn',{staticClass:"mr-3",attrs:{"color":"primary","dark":"","medium":""},on:{"click":_vm.redirectToProducts}},[_vm._v(" "+_vm._s(_vm.$t('marketplace.common.products'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }